module.exports = __webpack_public_path__ + "img/thankyouHeader.49c680d5.jpg";